import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "./Testimonials.module.css";

const Testimonials = () => {
  const [reviews, setReviews] = useState([]);

  // --- 1. FETCH REVIEWS FROM DATABASE ---
  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const res = await axios.get("/api/testimonials");
        if (res.data && res.data.length > 0) {
          setReviews(res.data);
        }
      } catch (error) {
        console.log("Backend offline or empty. Using default testimonials.");
      }
    };
    fetchReviews();
  }, []);

  // --- 2. FALLBACK CONTENT ---
  const defaultReviews = [
    {
      _id: "1",
      name: "Bethlehem T.",
      role: "Coffee Lover",
      feedback: "The best Macchiato in Addis! The atmosphere is amazing.",
    },
    {
      _id: "2",
      name: "Dawit M.",
      role: "Regular Customer",
      feedback: "I buy their roasted beans every week. Premium quality.",
    },
    {
      _id: "3",
      name: "Sarah J.",
      role: "Tourist",
      feedback:
        "Incredible flavor profile. Highly recommend visiting the roastery.",
    },
    {
      _id: "4",
      name: "Kaleb A.",
      role: "Foodie",
      feedback: "Great service and even better coffee.",
    },
  ];

  // --- 3. LIMIT TO 4 LATEST REVIEWS ---
  // Use DB reviews if available, otherwise defaults.
  // Then .slice(0, 4) ensures we never show more than 4 cards.
  const allReviews = reviews.length > 0 ? reviews : defaultReviews;
  const displayList = allReviews.slice(0, 4);

  return (
    <section className={styles.testimonialsSection}>
      <h3>Customer Feedback</h3>

      <div className={styles.testimonialsGrid}>
        {displayList.map((review) => (
          <div key={review._id} className={styles.testimonialCard}>
            <p>"{review.feedback}"</p>
            <div className={styles.userInfo}>
              <span className={styles.userName}>- {review.name}</span>
              <br />
              {review.role && (
                <small style={{ color: "#777", fontSize: "0.85rem" }}>
                  {review.role}
                </small>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
